/* @ngInject */
function AccessListController ($scope, $timeout, $translate, UdsModalService, $q) {
  const getPermissionsSettingsDialogController = () => {
    return $q.when(import('../../dialogs/permissions-settings/permissions-settings-dialog.controller'))
  }

  $scope.allItems = {
    toShow: [],
    toHide: []
  }

  const api = {
    getPermissionsSettingsDialogController,
    _defineItemsToShow
  }
  this.getApi = () => api

  function activate () {
    api._defineItemsToShow()
  }

  activate()

  $scope.getItemsTooltip = (items) => {
    let text = ''

    items.forEach(item => {
      text += `${item.label}<br>`
    })

    return text
  }

  function _defineItemsToShow () {
    const listWidth = $('.access-list-row .access-list').width()
    let occupiedWidth = 0
    const pillPadding = 16
    const characterAvgWidth = 7

    let index = 0

    while (listWidth >= occupiedWidth && $scope.itemsToShow.length - 1 >= index) {
      const items = $scope.itemsToShow[index]
      const itemsCharacterWidth = items.label.length * characterAvgWidth
      occupiedWidth += itemsCharacterWidth + pillPadding

      if (listWidth >= occupiedWidth) {
        $scope.allItems.toShow.push(items)
      } else {
        $scope.allItems.toHide.push(items)
      }

      index++
    }

    if ($scope.itemsToShow.length - 1 >= index) {
      const hiddenItems = $scope.itemsToShow.slice(index, $scope.itemsToShow.length)
      $scope.allItems.toHide.push(...hiddenItems)
    }
  }

  $scope.openPermissionsSettingsModal = () => {
    api.getPermissionsSettingsDialogController().then(({ PermissionsSettingsDialogController }) => {
      const permissionsSettingsDialog = UdsModalService.createModal({
        controller: PermissionsSettingsDialogController,
        modalName: 'permissionsSettings',
        data: {
          loadMoreItems: $scope.loadMoreItems,
          listInfo: $scope.data,
          itemType: $scope.itemType
        }
      })
      permissionsSettingsDialog.open()
    })
  }
}

export { AccessListController }
